import { render, staticRenderFns } from "./WxFormContainer.vue?vue&type=template&id=fd76a382&scoped=true"
import script from "./WxFormContainer.vue?vue&type=script&lang=js"
export * from "./WxFormContainer.vue?vue&type=script&lang=js"
import style0 from "./WxFormContainer.vue?vue&type=style&index=0&id=fd76a382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd76a382",
  null
  
)

export default component.exports